/**
 * How many of a cell's tag pills to draw whole, in order, before a "+N" pill for the rest: every one when they all
 * fit, otherwise as many as leave room for the "+N" pill after them. At least none - a cell too narrow for even one
 * pill shows "+N" alone.
 *
 * widths are the pills' own widths, gap the space between any two, plusWidth the "+N" pill's width.
 */
export const pillsThatFit = (widths: number[], available: number, gap: number, plusWidth: number): number => {
  const total = widths.reduce((sum, width) => sum + width, 0) + gap * Math.max(widths.length - 1, 0);
  if (total <= available) return widths.length;
  let used = plusWidth;
  let count = 0;
  for (const width of widths) {
    if (used + width + gap > available) break;
    used += width + gap;
    count++;
  }
  return count;
};
